import { z } from "zod";
import { RevisionIdSchema } from "../primitives/ids.js";
import { PatchOperationListSchema } from "./patch-operation.js";
/** D-038 — patch applicability reason codes + Tier 1 Step 5 client-safe extensions (T1-D-007). */
export const PatchApplicabilityReasonSchema = z.enum([
    "FIELD_NOT_RENDERABLE_BY_ACTIVE_PACK",
    "FIELD_NOT_FOUND",
    "PATCH_VERSION_MISMATCH",
    "TENANT_SCOPE_MISMATCH",
    "INVALID_PATCH_SHAPE",
    /** Client-safe L1 (Portal HARD semantics — T1-D-007 §9). */
    "FIELD_NOT_ALLOWED_L1",
    "VALUE_FAILED_CLIENT_SAFE_VALIDATION",
    "VALUE_REQUIRES_AGENCY_REVIEW",
    "UNSUPPORTED_FOR_CURRENT_INDUSTRY_PACK",
    /** Tier 1 Step 6 — agency L2 only. */
    "RAW_MARKUP_INJECTION_FORBIDDEN",
    "UNSUPPORTED_TRUST_CLAIM",
    "FAKE_REVIEW_OR_RATING_FORBIDDEN",
    "QA_BYPASS_FORBIDDEN",
    "STALE_BASE_REVISION",
]);
export const ClientSafeEditPatchV1Schema = z
    .object({
    schemaVersion: z.literal("client-safe-edit-patch.v1.0"),
    patchId: z.string().min(1),
    operations: PatchOperationListSchema,
    reasonCodes: z.array(PatchApplicabilityReasonSchema).optional(),
})
    .strict();
export const AgencyEditorPatchV1Schema = z
    .object({
    schemaVersion: z.literal("agency-editor-patch.v1.0"),
    patchId: z.string().min(1),
    /** Optional optimistic concurrency — must match active BG revision head when provided. */
    baseRevisionId: RevisionIdSchema.optional(),
    operations: PatchOperationListSchema,
    reasonCodes: z.array(PatchApplicabilityReasonSchema).optional(),
})
    .strict();
/** FIELD_NOT_RENDERABLE_BY_ACTIVE_PACK is warning for L1/L2 agency path per D-038. */
export function isNonBlockingPatchReason(reason) {
    return reason === "FIELD_NOT_RENDERABLE_BY_ACTIVE_PACK";
}
//# sourceMappingURL=patches.js.map